import React from "react";
 
interface ClientGateProps {
    clients: string[];
    children: React.ReactNode;
    canRender?: boolean;
}

export const getClientGate = (clients: string[], canRender = true): boolean => {
    const brand = (import.meta.env.VITE_APP_BRAND || "").toUpperCase();
    const isClientAllowed = clients.map(c => c.toUpperCase()).includes(brand);
    return canRender === isClientAllowed;
};
 
export const ClientGate: React.FC<ClientGateProps> = ({
    clients,
    children,
    canRender = true,
}) => {
 
    const brand = (import.meta.env.VITE_APP_BRAND || "").toUpperCase();
    const isClientAllowed = clients.map(c => c.toUpperCase()).includes(brand);
 
    if (canRender !== isClientAllowed) {
        return null;
    }
 
    return <>{children}</>;
};